/**
 * Created by JackCui on 2021/1/12
 */

import moment from 'moment'
import {symbolHandle} from './jsonLogic/symbolHandle'
import {getUserInfo, getOrganization} from '../../store/local-catch/user'

/**
 * 保存全部规则所用到的字段信息 {key:field}
 * 目前为全局变量共享到每一个引用的地方
 * 因为目前key完全唯一 所以没有清空操作
 * TODO 可能会导致在规则复杂的情况下内存占用过高 目前可以忽略不计
 * @type {{}}
 */
export let ruleValueParamModelsMap = {}

/**
 * 常量类型处理函数
 */
const constValueHandleMap = {
  'SystemCurrentUserMainDepart': (symbol) => {
    const symbolKey = {'BELONG_TO': 'code'}
    const key = symbolKey[symbol] || 'id'
    return getOrganization()?.[key]
  },
  'SystemCurrentUser': (symbol) => {
    const symbolKey = {'BELONG_TO': 'code'}
    const key = symbolKey[symbol] || 'id'
    return getUserInfo()?.[key]
  },
  'SystemCurrentTime': () => moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
  'SystemCurrentDate': () => moment(new Date()).format('YYYY-MM-DD')
}

/**
 * 全局常量处理函数
 * @param value
 * @param valueType
 * @param symbol
 * @returns {*}
 */
const modelValueHandle = ({value, valueType}, symbol) => {
  const typeMap = {
    'variableType': function () {
      // TODO SystemCurrentUserMainDepart后面会拼接@id/@code 需要切割一下
      const key = value.toString().split('@')[0]
      return constValueHandleMap[key](symbol)
    },
    'inputType': function () {
      return value
    }
  }

  return typeMap[valueType] && typeMap[valueType]()
}

/**
 * 解析表达式
 * @param express
 * @returns {{}}
 *  {
 *    'paas-shortText-EQUAL': [1, 2]
 *  }
 */
export default function (express) {
  const {
    expressSymbolModel: {symbol},
    expressValueModel,
    expressParamModel: {
      type: fieldType,
      apiName: fieldApiName,
      objectApiName: originObjectApiName,
      key
    }
  } = express
  const symbolKey = `${fieldType}-${symbol}`
  // 生成变量
  const value = {'var': `${originObjectApiName}_${fieldApiName}`}

  // 全局缓存规则express 提交值的时候用
  ruleValueParamModelsMap[key] = express

  // 判断无效参数校验
  if (!(symbolHandle[fieldType] && symbolHandle[fieldType][symbol])) {
    throw new Error(`${symbolKey}:找不到当前表达式操作.`)
  }

  return {
    express: {
      [symbolKey]: [value, modelValueHandle(expressValueModel, symbol)]
    },
    expressKey: {
      varKey: `${originObjectApiName}_${fieldApiName}`,
      objectApiName: originObjectApiName
    }
  }
}
